import React, { useState } from 'react'
import { useLocation } from 'react-router-dom';
import { Fab, Action } from 'react-tiny-fab';
import 'react-tiny-fab/dist/styles.css';
import AddIcon from '@material-ui/icons/Add';
import CreateIcon from '@material-ui/icons/Create';
import AddClient from '../Invoice/AddClient';
import AddProduct from '../Invoice/AddProduct';
import styles from './Fab.module.css'



const FabButton = () => {

  const location = useLocation()
  const mainButtonStyles = {backgroundColor: '#1976D2'}
  const [open, setOpen] = useState(false)


  // if(location.pathname === '/invoice') return null

    return (
        <div className={styles.fabVisibility}>
          <AddProduct setOpen={setOpen} open={open} />
          <AddClient setOpen={setOpen} open={open} />
          <Fab
            mainButtonStyles={mainButtonStyles}
            icon={ <AddIcon />}
            alwaysShowTitle={true}
          >

            {location.pathname !== '/invoice' && (
              <Action
                  text="New Invoice"
                  // onClick={() =>  history.push(`/invoice`)}
                  onClick={() => window.location.href='/invoice'}
                >
                  <CreateIcon />
              </Action>
            )}
            {location.pathname !== '/customers' && (
              <Action
                  text="New Customer"
                  // onClick={() =>  history.push(`/invoice`)}
                  onClick={() => window.location.href='/customers'}
                >
                  <CreateIcon />
              </Action>
            )}
            {location.pathname !== '/lockups' && (
              <Action
                  text="New Lockup"
                  // onClick={() =>  history.push(`/invoice`)}
                  onClick={() => window.location.href='/lockups'}
                >
                  <CreateIcon />
              </Action>
            )}
            {location.pathname !== '/products' && (
              <Action
                  text="New Product"
                  // onClick={() =>  history.push(`/invoice`)}
                  onClick={() => window.location.href='/products'}
                >
                  <CreateIcon />
              </Action>
            )}
            {location.pathname !== '/routes' && (
              <Action
                  text="New Route"
                  // onClick={() =>  history.push(`/invoice`)}
                  onClick={() => window.location.href='/routes'}
                >
                  <CreateIcon />
              </Action>
            )}
            
            {/* <Action
                text="New Customer"
                onClick={() => setOpen((prev) => !prev)}
              >
                <PersonAddIcon />
            </Action>
            
            <Action
                text="New Product"
                onClick={() => setOpen((prev) => !prev)}
              >
                <AddToQueueIcon />
            </Action> */}

          </Fab>
        </div>
    )
}

export default FabButton
